<template>
  <section class="space-audit">
    <div class="go-back" @click="goback">返回></div>
    <el-divider></el-divider>
    <div class="gap"></div>
    <div class="applicant">
      <span class="title"
        >申请人<span style="margin-left:30px">{{
          record.parkingOwner
        }}</span></span
      >
    </div>
    <div class="gap"></div>
    <section>
      <div class="title">流程进度</div>
      <div class="gap"></div>
      <el-steps :active="active" align-center>
        <el-step
          v-for="(item, index) in processSteps"
          :key="index"
          :title="item.date"
          :description="
            `${item.description}${
              item.auditStep == 2 ? item.isPassed : ''
            }`
          "
        ></el-step>
      </el-steps>
    </section>
    <div class="gap"></div>
    <div class="gap"></div>
    <section>
      <div class="title">操作记录</div>
      <div class="gap"></div>
      <el-timeline>
        <el-timeline-item
          placement="top"
          v-for="(item, index) in recordLine"
          :key="index"
          color="#409EFF"
        >
          <el-card v-if="item.step!==3">
            <p >
              <span v-if="item.step===0">事件:提交审核</span>
              <span v-else>事件:【平台审核】{{ item.reason }}</span>
            </p>
            <p v-if="item.step===0">时间:{{ item.auditTime }}</p>
            <p v-if="item.step!==0">操作账号:{{ item.auditUser }}</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </section>
    <div class="gap"></div>
    <div class="title">信息记录</div>
    <div class="gap"></div>
    <section class="record">
      <div class="record-title">车位产权证明/购买证明</div>
      <div class="gap"></div>
      <div class="demo-image__preview" style="display:flex;justify-content: flex-start;">
        <div v-for="item in (record.parkingProof?record.parkingProof.split(','):[])" :key="item"  style="margin-right:10px; border-radius: 20px;">
          <el-image 
      
      style="width: 100px; height: 100px"
      :src="item" 
      :preview-src-list="record.parkingProof?record.parkingProof.split(','):[]">
    </el-image>
        </div>
 
</div>
      <div>
      
      </div>
    </section>
    <div class="gap"></div>
    <section class="record">
      <div class="record-title">身份证信息</div>
      <div class="gap"></div>
      <div class="demo-image__preview" style="display:flex;justify-content: flex-start;">
        <div v-for="item in (record.userIdInfo?record.userIdInfo.split(','):[])" :key="item"  style="margin-right:10px; border-radius: 20px;">
          <el-image 
      
      style="width: 100px; height: 100px"
      :src="item" 
      :preview-src-list="record.userIdInfo?record.userIdInfo.split(','):[]">
    </el-image>
        </div>
 
</div>
    </section>
    
    <!-- <section class="record">
      <div class="record-title">基本信息</div>
      <div class="gap"></div>

      <div>
        <ul>
          <li>客户名称： {{ baseInfo.name }}</li>
          <li>营业执照： {{ baseInfo.businessLicense }}</li>
          <li>类型： {{ baseInfo.type }}</li>
          <li>停车场： {{ baseInfo.parkingName }}</li>
          <li>城市： {{ baseInfo.city }}</li>
          <li>联系人： {{ baseInfo.contactPerson }}</li>
        </ul>
      </div>
    </section>
    <div class="gap"></div>
    <section class="record">
      <div class="record-title">详细信息</div>
      <div class="gap"></div>
      <div>
        <ul>
          <li>首联系人： {{ baseInfo.name }}</li>
          <li>手机号码： {{ baseInfo.businessLicense }}</li>
          <li>车位详细地址： {{ baseInfo.type }}</li>
          <li>公司电话： {{ baseInfo.city }}</li>
          <li>发票抬头： {{ baseInfo.contactPerson }}</li>
          <li>企业税号： {{ baseInfo.parkingName }}</li>
        </ul>
      </div>
    </section>
    <div class="gap"></div>
    <section class="record">
      <div class="record-title">计费规则</div>
      <div class="gap"></div>
      <div>
        <ul>
          <li>计费时段： {{ baseInfo.name }}</li>
          <li>包月： {{ baseInfo.businessLicense }}</li>
        </ul>
      </div>
    </section> -->
    <section class="operate" v-if="isShowAuditBtn">
      <el-button
        class="resolve-button"
        type="primary"
        size="small"
        @click="onAuditBtn({ isPassed: true })"
        >通过</el-button
      >
      <el-button
        class="reject-button"
        type="primary"
        size="small"
        @click="onAuditBtn({ isPassed: false })"
        >驳回</el-button
      >
    </section>
  </section>
</template>
<script>
import { shareSpaceDetail, shareSpaceAudit } from "@/api/url";
export default {
  data: function() {
    return {
      active: 0,
      processSteps: [
        {
          date: "",
          description: "提交申请",
          status: "application",
          auditStep: 0,
        },
        // {
        //   date: "",
        //   description: "物业审批",
        //   status: "property",
        //   auditStep: 1,
        //   isPassed: "",
        // },
        {
          date: "",
          description: "平台审批",
          status: "platform",
          auditStep: 2,
          isPassed: "",
        },
        {
          date: "",
          description: "结束",
          status: "success",
          auditStep: 3,
        },
      ],
      recordLine: [
        {
          title: "更新 Github 模板",
          date: "2024-01-09",
          content: "王小虎 提交于 2018/4/12 20:46",
        },
        {
          title: "更新 Github 模板",
          date: "2024-01-09",
          content: "王小虎 提交于 2018/4/12 20:46",
        },
      ],
      baseInfo: {
        name: "深圳木卫二科技有限公司",
        businessLicense: "SZ5598716453287",
        type: "个人",
        parkingName: "友谊天下停车场",
        city: "深圳",
        contactPerson: "MMM",
      },
      record: {},
      isShowAuditBtn: false,
    };
  },
  mounted() {
    this.record = JSON.parse(this.$route?.query?.space ?? "{}");
    this.step= JSON.parse(this.$route?.query?.step ?? "");
    this.record?.auditStatus == 1
      ? (this.isShowAuditBtn = true)
      : (this.isShowAuditBtn = false);
    console.log("record=>", this.record);
    this.getShareSpaceDetail();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    getShareSpaceDetail() {
      const { id, auditStep} = this.record;
      this.active = Number(auditStep + 1);
      this.$get(`${shareSpaceDetail()}/${id}`).then((res) => {
        const {
          status,
          data: { audits },
        } = res;
        if (status !== 200) return;
        this.recordLine = audits;
        this.processSteps = [...this.processSteps].map((item) => {
          if (item.auditStep == 2) {
            const isPassed = audits.find(
              (audit) => audit.step == item.auditStep
            )?.isPassed;
            if (isPassed === undefined) {
              item.isPassed = "";
            } else if (isPassed) {
              item.isPassed = "通过";
            } else {
              item.isPassed = "驳回";
            }
          }
          const audit = audits.find((audit) => audit.step == item.auditStep);
          item.date = audit?.auditTime;
          return item;
        });
        console.log("process steps=>", this.processSteps);
      });
    },
    /**
     * 审核
     * @param {Object} data
     */
    onAuditBtn(data) {
      const { isPassed } = data;
      this.$prompt(isPassed ? "通过" : "驳回", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        const { id } = this.record;
        /**
         * id: "1",
         * step: 1,//1：物业审核、2：平台审核
         * isPassed: true,//true：通过、false：不通过
         * description:''
         */
        const params = {
          id,
          step: this.step,
          isPassed,
          reason: value,
        };
        this.$postRequest(shareSpaceAudit(), { ...params }).then((res) => {
          console.log("res=>", res);
          this.$message({
            type: "success",
            message: "审核成功",
          });
          this.$router.go(-1);
        });
      });
    },
    handleAuditStatus(data) {
      switch (data.auditStatus) {
        case 0:
          return "审核通过";

        case 1:
          return "待审核";

        case 2:
          return "审核不通过";

        default:
          return "";
      }
    },
  },
};
</script>
<style scoped>
.go-back {
  font-size: 16px;

  cursor: pointer;
  color: #409eff;
}
.space-audit {
  padding: 20px;
  overflow-y: auto;
  height: 100%;
  padding-bottom: 150px;
}
.gap {
  padding-bottom: 20px;
  box-sizing: border-box;
}
.record ul {
  width: 100%;
  display: flex;
  justify-content: flex-start;

  flex-wrap: wrap;
}
.record ul li {
  width: 50%;
  padding: 5px 0;
  box-sizing: border-box;
}
.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}
.record-title {
  font-size: 16px;
  font-weight: bold;
  color: #666;
}
.operate {
  width: 100%;
  height: 100px;
  position: fixed;
  bottom: 0;
  left: 16%;
  background: white;
  padding-left: 18%;
  box-shadow: 0px -10px 20px #f3f3f3;
  padding-top: 20px;
  box-sizing: border-box;
}
.resolve-button {
  width: 300px;
  height: 60px;
  margin-right: 20px;
  font-size: 30px;
  letter-spacing: 4px;
}
.reject-button {
  width: 300px;
  height: 60px;
  font-size: 30px;
  letter-spacing: 4px;
}

</style>
<style>
.el-select{
	display: block;
   }

</style>
